import { render, staticRenderFns } from "./IconAsterix.vue?vue&type=template&id=986aec12"
import script from "./IconAsterix.vue?vue&type=script&lang=ts"
export * from "./IconAsterix.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports